import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

interface Version {
	commit: string | null
	deployedAt: string
}

const REPO = 'https://github.com/bengottlieb/AppOutlet'

/** Which build is running: its commit and when it was deployed, in the viewer's local time. */
export function SiteFooter() {
	const version = useQuery({
		queryKey: ['version'],
		queryFn: () => api.get<Version>('/api/version'),
		staleTime: Infinity,
	})
	if (!version.data) return null
	const { commit, deployedAt } = version.data
	const when = new Date(deployedAt).toLocaleString(undefined, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		timeZoneName: 'short',
	})
	return (
		<footer className="site-footer muted small">
			{commit ? (
				<a href={`${REPO}/commit/${commit}`} target="_blank" rel="noreferrer" className="mono">
					{commit}
				</a>
			) : (
				'Unknown build'
			)}{' '}
			· deployed {when}
		</footer>
	)
}
